/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LanguageDto } from '../models/language-dto';

@Injectable({
  providedIn: 'root',
})
export class LanguageRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getLanguageById
   */
  static readonly GetLanguageByIdPath = '/api/v1/languageController/{id}';

  /**
   * Provides LanguageDto based on given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLanguageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LanguageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LanguageRestControllerService.GetLanguageByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LanguageDto>;
      })
    );
  }

  /**
   * Provides LanguageDto based on given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLanguageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<LanguageDto> {

    return this.getLanguageById$Response(params,context).pipe(
      map((r: StrictHttpResponse<LanguageDto>) => r.body as LanguageDto)
    );
  }

  /**
   * Path part for operation getLanguages
   */
  static readonly GetLanguagesPath = '/api/v1/languageController/all';

  /**
   * Provides the list of all Languages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguages$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<LanguageDto>>> {

    const rb = new RequestBuilder(this.rootUrl, LanguageRestControllerService.GetLanguagesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LanguageDto>>;
      })
    );
  }

  /**
   * Provides the list of all Languages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguages(params?: {
  },
  context?: HttpContext

): Observable<Array<LanguageDto>> {

    return this.getLanguages$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<LanguageDto>>) => r.body as Array<LanguageDto>)
    );
  }

  /**
   * Path part for operation deletelanguage
   */
  static readonly DeletelanguagePath = '/api/v1/languageController/{skillId}';

  /**
   * Removes Language passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletelanguage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deletelanguage$Response(params: {
    skillId: number;
    body: LanguageDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, LanguageRestControllerService.DeletelanguagePath, 'delete');
    if (params) {
      rb.path('skillId', params.skillId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Language passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletelanguage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deletelanguage(params: {
    skillId: number;
    body: LanguageDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deletelanguage$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
